/* tslint:disable */

/**
 */
export class MembershipPayBackForm {
    id?: number;
    rfid?: string;
    barcode?: string;
}
